import { useEffect, useLayoutEffect } from 'react';

import { isServer } from '@/lib/utils';

export const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;
